<polpo-legals-hero></polpo-legals-hero>

<div class="[ container p-be-3xl stack ]">
  <ng-container *ngIf="slug$ | async as slug">
    <polpo-legals-page-privacy *ngIf="slug === 'privacy'"></polpo-legals-page-privacy>
    <polpo-legals-page-sales-conditions *ngIf="slug === 'verkoopsvoorwaarden'"></polpo-legals-page-sales-conditions>
    <polpo-legals-page-terms-of-use *ngIf="slug === 'gebruiksvoorwaarden'"></polpo-legals-page-terms-of-use>
    <polpo-legals-page-ai *ngIf="slug === 'ai'"></polpo-legals-page-ai>
  </ng-container>
</div>
